module.exports = __webpack_public_path__ + "img/404.cc5a5190.jpg";